// PostHog init
export { initPostHog, posthog, stopHeartbeat } from './posthog';

// User identity
export { identifyUser, resetUser } from './identity';
export type { UserIdentity } from './identity';

// Page context super properties
export { usePageContext } from './usePageContext';
export type { PageContext, PageType } from './usePageContext';

// Feed visibility (scroll engagement)
export { useTrackEntityVisibility } from './useTrackEntityVisibility';
export type { UseTrackEntityVisibilityOptions } from './useTrackEntityVisibility';

// Content view tracking (time + scroll depth)
export { useTrackContentView } from './useTrackContentView';

// Autocapture tagging strategy
export { getDataPh, DataPhTags, isValidDataPhTag } from './tagging';
export type { DataPhTag } from './tagging';

// Type definitions
export type {
  GlobalEventContract,
  EventMap,
  EventName,
  EventProperties
} from './types';

// Flat event properties (ONLY schema - native implementation)
export type { FlatEventProperties } from './flatTypes';

// Backend events

// All custom events — import what you need
export * from './events';

// Content analysis utilities
export * from './contentAnalysis';
